export const Jalandhar = [
    {
      id: 1,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404812/WhatsApp_Image_2025-02-01_at_11.57.37_AM_cd42ml.jpg",
      alt: "Jalandhar  Event 1",
    },
    {
      id: 2,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404811/WhatsApp_Image_2025-02-01_at_11.57.36_AM_nwz0vm.jpg",
      alt: "Jalandhar  Event 2",
    },
    {
      id: 3,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404811/WhatsApp_Image_2025-02-01_at_11.57.35_AM_cyizcr.jpg",
      alt: "Jalandhar  Event 3",
    },
    {
      id: 4,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404704/WhatsApp_Image_2025-02-01_at_11.57.13_AM_wvo0sm.jpg",
      alt: "Jalandhar  Event 4",
    },
    {
      id: 5,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404810/WhatsApp_Image_2025-02-01_at_11.57.33_AM_iigjqk.jpg",
      alt: "Jalandhar  Event 5",
    },
    {
      id: 6,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404809/WhatsApp_Image_2025-02-01_at_11.57.32_AM_psrdg8.jpg",
      alt: "Jalandhar  Event 6",
    },
    {
      id: 7,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404809/WhatsApp_Image_2025-02-01_at_11.57.31_AM_g8o91j.jpg",
      alt: "Jalandhar  Event 7",
    },
    {
      id: 8,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404808/WhatsApp_Image_2025-02-01_at_11.57.30_AM_rlxjqn.jpg",
      alt: "Jalandhar  Event 8",
    },
    {
      id: 9,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404807/WhatsApp_Image_2025-02-01_at_11.57.27_AM_nnydmq.jpg",
      alt: "Jalandhar  Event 9",
    },
    {
      id: 10,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404808/WhatsApp_Image_2025-02-01_at_11.57.29_AM_uykyco.jpg",
      alt: "Jalandhar  Event 10",
    },
    {
      id: 11,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404807/WhatsApp_Image_2025-02-01_at_11.57.27_AM_1_rcr34v.jpg",
      alt: "Jalandhar  Event 11",
    },
    {
      id: 12,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404807/WhatsApp_Image_2025-02-01_at_11.57.25_AM_kufzei.jpg",
      alt: "Jalandhar  Event 12",
    },
    {
      id: 13,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404763/WhatsApp_Image_2025-02-01_at_11.57.24_AM_fjjl4w.jpg",
      alt: "Jalandhar  Event 13",
    },
    {
      id: 14,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404738/WhatsApp_Image_2025-02-01_at_11.57.24_AM_1_jriqj1.jpg",
      alt: "Jalandhar  Event 14",
    },
    {
      id: 15,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404738/WhatsApp_Image_2025-02-01_at_11.57.23_AM_yufwzo.jpg",
      alt: "Jalandhar  Event 15",
    },
    {
      id: 16,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404723/WhatsApp_Image_2025-02-01_at_11.57.22_AM_snptdd.jpg",
      alt: "Jalandhar  Event 16",
    },
    {
      id: 17,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404705/WhatsApp_Image_2025-02-01_at_11.57.19_AM_l75mvf.jpg",
      alt: "Jalandhar  Event 17",
    },
    {
      id: 18,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404705/WhatsApp_Image_2025-02-01_at_11.57.21_AM_wptvvv.jpg",
      alt: "Jalandhar  Event 18",
    },
    {
      id: 19,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404705/WhatsApp_Image_2025-02-01_at_11.57.20_AM_vh2hzk.jpg",
      alt: "Jalandhar  Event 19",
    },
    {
      id: 20,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404705/WhatsApp_Image_2025-02-01_at_11.57.18_AM_lrwfe9.jpg",
      alt: "Jalandhar  Event 20",
    },
    {
      id: 21,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404704/WhatsApp_Image_2025-02-01_at_11.57.15_AM_cadxj5.jpg",
      alt: "Jalandhar  Event 21",
    },
    {
      id: 22,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404704/WhatsApp_Image_2025-02-01_at_11.57.14_AM_zgckvk.jpg",
      alt: "Jalandhar  Event 22",
    },
    {
      id: 23,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404704/WhatsApp_Image_2025-02-01_at_11.57.16_AM_v7dez9.jpg",   
      alt: "Jalandhar  Event 23",
    },
    {
      id: 24,
      src: "https://res.cloudinary.com/dtivafy25/image/upload/v1738404704/WhatsApp_Image_2025-02-01_at_11.57.13_AM_wvo0sm.jpg",
      alt: "Jalandhar  Event 24",
    },
  ];